import { IonLabel, IonTabBar, IonTabButton } from '@ionic/react';
import HomeIcon from '../../assets/icons/HomeIcon';
import MenuIcon from '../../assets/icons/MenuIcon';
import OrdersIcon from '../../assets/icons/OrdersIcon';
import { useTranslation } from 'react-i18next';

const Footer = () => {
  const { t } = useTranslation(null, { keyPrefix: 'Modules:Mobile:Components:Footers:Footer' });

  return (
    <IonTabBar
      slot="bottom"
      className="h-20 ion-color overflow-hidden bg-white rounded-t-3xl backdrop-blur-md shadow-[0_-4px_8px_rgba(0,0,0,0.12)]"
    >
      <IonTabButton tab="home" className="[&.tab-selected]:text-brand-primary group space-y-2 text-gray-700">
        <HomeIcon className="h-[26px] group-[.tab-selected]:stroke-brand-primary stroke-mobile-secondary" />
        <IonLabel className="text-xs">{t('tabs.home')}</IonLabel>
      </IonTabButton>
      <IonTabButton tab="menu" className="[&.tab-selected]:text-brand-primary group space-y-2 text-gray-700">
        <MenuIcon className="h-[26px] group-[.tab-selected]:stroke-brand-primary stroke-mobile-secondary" />
        <IonLabel className="text-xs">{t('tabs.menu')}</IonLabel>
      </IonTabButton>
      <IonTabButton tab="orders" className="[&.tab-selected]:text-brand-primary group space-y-2 text-gray-700">
        <OrdersIcon className="h-[26px] group-[.tab-selected]:stroke-brand-primary stroke-mobile-secondary" />
        <IonLabel className="text-xs">{t('tabs.orders')}</IonLabel>
      </IonTabButton>
    </IonTabBar>
  );
};

export default Footer;
